export default __webpack_public_path__ + "locales/ru/DeleteProfileEverDialog.json?hash=695927a94ad903b81653a832e35afd67";